import { createAsyncThunk } from "@reduxjs/toolkit";

export const purchaseAction = createAsyncThunk(
    "purchaseAction",
    async (data) => {
        const response = await fetch(
            "https://52lku5p2bj.execute-api.ap-south-1.amazonaws.com/Prod/prod_brilljust_purchaseProduct_New",
            // "https://52lku5p2bj.execute-api.ap-south-1.amazonaws.com/Prod/brilljustPolicyPurchas_test",
            {
                method: "POST",
                body: JSON.stringify(data.data),
                headers: new Headers({
                    "Authorization": `${data.userToken}`,
                    'Content-Type': 'application/json'
                }),
            }
        );
        return response.json();
    }
);